const SDK_VERSION = '8.23.0';

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
